var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_293","data-name":"Path 293","d":"M57.565,164.82H35.652A3.656,3.656,0,0,0,32,168.472v13.7a3.656,3.656,0,0,0,3.652,3.652H57.565a3.656,3.656,0,0,0,3.652-3.652v-13.7A3.656,3.656,0,0,0,57.565,164.82ZM57.23,171l-10.043,8.217a.913.913,0,0,1-1.156,0L35.987,171a.913.913,0,1,1,1.156-1.413l9.466,7.744,9.466-7.744A.913.913,0,1,1,57.23,171Z","transform":"translate(-32 -164.82)"}));
}

Mail.defaultProps = {"width":"29.217","height":"21","viewBox":"0 0 29.217 21"};

module.exports = Mail;

Mail.default = Mail;
